import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
const TONE = {
    default: 'text-[var(--text)]',
    success: 'text-[var(--success)]',
    warning: 'text-[var(--accent)]',
};
export const MetricTile = forwardRef(function MetricTile({ label, value, tone = 'default', className, ...rest }, ref) {
    return (_jsxs("article", { ref: ref, className: cn('grid gap-2 min-h-[106px] p-4 bg-[var(--surface)] border border-[var(--border)] rounded-[var(--radius-card)]', className), ...rest, children: [_jsx("span", { className: "text-[var(--text-muted)] text-sm", children: label }), _jsx("strong", { className: cn('font-mono text-[34px] leading-none font-extrabold', TONE[tone]), children: value })] }));
});
//# sourceMappingURL=MetricTile.js.map